import { render, staticRenderFns } from "./CafeteriaPage.vue?vue&type=template&id=6b50c78e"
import script from "./CafeteriaPage.vue?vue&type=script&lang=js"
export * from "./CafeteriaPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports